import { useState } from 'react';

const FORM_URL = 'http://my783e.cn/';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotField = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const formData = new FormData(form);
      if (honeypotField) {
        formData.delete('website_alt');
      }

      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，每日最新爆料将第一时间送达。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        if (serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后重试');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section className="relative w-full min-h-[400px] md:min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20theater%20stage%20with%20red%20velvet%20curtains%20partially%20open%2C%20single%20warm%20spotlight%20center%2C%20mysterious%20and%20inviting%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20empty%20stage%20ready%20for%20a%20show%2C%20elegant%20theatrical%20setting%2C%20editorial%20photography&width=1600&height=900&seq=cta-subscribe-bg&orientation=landscape"
          alt="订阅吃瓜网每日爆料"
          title="吃瓜网官网 - 订阅每日吃瓜"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-md">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4">
              不错过每一个瓜
            </h2>
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-6">
              订阅吃瓜网每日爆料，第一时间获取网红塌房、明星黑料、博主反差等最新热门内容。
            </p>

            <form
              id="cta-subscribe-form"
             
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-3"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                className="flex-1 px-5 py-3 rounded-lg bg-background-50/95 text-foreground-950 text-sm border-none outline-none placeholder:text-foreground-400 focus:ring-2 focus:ring-primary-400 transition-all"
                required
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-all duration-200 disabled:opacity-60"
              >
                {status === 'loading' ? '订阅中...' : '免费订阅'}
              </button>
            </form>

            {status === 'success' && (
              <p className="mt-4 text-sm text-accent-400 font-medium">{message}</p>
            )}
            {status === 'error' && (
              <p className="mt-4 text-sm text-primary-400 font-medium">{message}</p>
            )}

            <p className="mt-4 text-xs text-background-50/50">
              已服务超过 50,000+ 忠实吃瓜群众，每日准时送达
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}